function init() {
  const selectors = document.querySelectorAll(`
    h1,
    .h1,
    h2,
    h3:not(.is-style-collapsible__heading),
    h4,
    h5,
    h6,
    .main p,
    .main li,
    .header a > span,
    .footer-primary-menu a > span,
    .a-copyright__name,
    .wp-block-button__link
  `);

  selectors.forEach(function(selector) {
    selector.innerHTML = selector.innerHTML
      .replace(/\s&amp;\s/g, ' <span class="amp">&amp;</span> ')
      .replace(/D&amp;M/g, 'D<span class="amp">&amp;</span>M')
      .replace(/DE&amp;I/g, 'DE<span class="amp">&amp;</span>I')
    ;
  });
}

export {init as default};
